import styled from 'styled-components'

export const SCHr = styled.div<{ thin?: boolean }>`
  height: ${(p) => (p.thin ? '1' : '2')}px;
  background-color: ${(p) =>
    p.thin ? p.theme.uiKit.colors.global.grey.grey500 : p.theme.uiKit.colors.global.grey.grey300};
  margin: 12px 0;
`
